module.exports = __webpack_public_path__ + "static/media/Earnings.ad526f9f.svg";